import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PayFinePaymentDetails from "./PayFinePaymentDetails";
import { withStripePayment } from "../with-stripe-payment";
import {
  createPaymentIntent,
  getAllCardsAction,
  getPaymentIntentAction,
} from "../../../redux/services/payments/paymentServices";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import Spinner from "../spinner/Spinner";
import { payFineAction } from "../../../redux/services/common/commonServices";
import { toastService } from "../toast-messages/toast";
import { useStripe } from "@stripe/react-stripe-js";

const PayFine = withStripePayment(PayFinePaymentDetails);

const PayFinePaymentForm = () => {
  const stripe = useStripe();
  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  /* loading dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /* dialog dependencies */
  const [openPaymentConfirmationDialog, setOpenPaymentConfirmationDialog] =
    useState(false);
  /* dialog dependencies */

  const { loginDetails } = useSelector((state) => state.auth);

  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);

  const createPayment = async (
    newCardToken,
    selectedCard,
    resetDefaultFields
  ) => {

    const payment_method = selectedCard ? selectedCard : newCardToken?.card?.id;

    const dataToBeSent = {
      amount: systemSettings?.organization_account_fine_percentage,
      currency: systemSettings?.system_currency,
      order_id: null,
      event_type: "PAY_FINE",
      payment_method: payment_method,
      customer: loginDetails?.customer_stripe_token,
      new_card: newCardToken?.id ? true : false,
      token_id: newCardToken?.id || null
    };

    dispatch(createPaymentIntent(dataToBeSent, setSubmitLoader)).then(
      (apiRes) => {
        const paymentIntentResponse = apiRes;
        confirmCardPayment(resetDefaultFields, paymentIntentResponse, payment_method)
      }
    );
  };


  /* fuction definition to confirm card payment */
  const confirmCardPayment = async (resetDefaultFields, paymentIntentResponse, payment_method) => {
      if(paymentIntentResponse && paymentIntentResponse.id) {
        if(paymentIntentResponse.status === 'requires_action'){
          try {
            const confirmData = await stripe.confirmCardPayment(paymentIntentResponse.client_secret, {
              payment_method: payment_method,
            });
            if (confirmData.paymentIntent) {
              const dataToBeSent = {
                paymentIntentId: confirmData.paymentIntent.id
              }
              dispatch(getPaymentIntentAction(dataToBeSent, setSubmitLoader)).then((apiRes)=>{
                handleStripeResponse(resetDefaultFields, apiRes);
              })
            } else {
              toastService.error(confirmData?.error?.message);
              setSubmitLoader(false);
            }
          } catch (e) {
            toastService.error('Payment failed :' + e.message);
            setSubmitLoader(false);
          }
        }
        else {
          handleStripeResponse(resetDefaultFields, paymentIntentResponse);
        }
      }
  }
  /* fuction definition to confirm card payment */

  /* function definition to check the payment intent status */
  const handleStripeResponse = (resetDefaultFields, paymentIntentResponse) => {
    if (paymentIntentResponse.status === 'succeeded' || paymentIntentResponse.status === 'processing') {
      createPayFine(resetDefaultFields, paymentIntentResponse);
    }
    if (paymentIntentResponse.status === 'requires_payment_method') {
      toastService.error('Payment failed, please try again later');
      setSubmitLoader(false);
    }
  }
  /* function definition to check the payment intent status */

  const createPayFine = async (resetDefaultFields, paymentIntentResponse) => {
    // Take subscription plan details
    const dataToBeSent = {
      // user_id:loginDetails?.organization_id?._id,
      total_amount: systemSettings?.organization_account_fine_percentage,
      currency: systemSettings?.system_currency,
      subtotal_amount: systemSettings?.organization_account_fine_percentage,
      payment_intent_id: paymentIntentResponse?.id,
      charged_from_stripe: systemSettings?.organization_account_fine_percentage,
      charged_from_wallet: 0,
    };

    try {
      // Dispatch action to create subscription order
      await dispatch(payFineAction(dataToBeSent, setSubmitLoader)).then(
        (apiRes) => {
          if (apiRes) {
            setOpenPaymentConfirmationDialog(true);
            resetDefaultFields();
          }
        }
      );
    } catch (error) {
      setSubmitLoader(false);
      toastService.error("Something went wrong!");
      console.error("Error creating subscription order:", error);
      // Handle the error (e.g., show an error message to the user)
    }
  };

  /* load initial card dependencies - get data of previously used card */
  useEffect(() => {
    if (
      Object.keys(systemSettings)?.length === 0 ||
      systemSettings === null ||
      systemSettings === undefined
    ) {
      navigate(baseRouteMaker(routes.DASHBOARD));
    }
    dispatch(getAllCardsAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* load initial card dependencies - get data of previously used card */

  return loading ? (
    <Spinner />
  ) : (
    Object.keys(systemSettings)?.length !== 0 &&
      systemSettings !== null &&
      systemSettings !== undefined && (
        <PayFine
          submitLoader={submitLoader}
          createPayment={createPayment}
          openPaymentConfirmationDialog={openPaymentConfirmationDialog}
          setOpenPaymentConfirmationDialog={setOpenPaymentConfirmationDialog}
          applyCouponCode={false}
        />
      )
  );
};

export default PayFinePaymentForm;
